import { combineReducers } from "redux";
import componentStatus from "./componentStatus";
import clientConfig from "./clientConfig";
import experimentId from "./experiment";
import filter from "./filter";
import modal from "./modal";
import offerType from "./offerType";
import portalId from "./portal";
import portalData from "./portalData";
import sort from "./sort";

const rootReducer = combineReducers({
  clientConfig,
  componentStatus,
  experimentId,
  filter,
  modal,
  offerType,
  portalId,
  portalData,
  sort
});

export default rootReducer;
